(function(){
  /* single-init guard: heliaon.js is included once per section (x8 home / x5 PDP)
     and the theme editor re-runs section scripts on every change. Without this
     guard, scroll listeners + observers accumulate and thrash layout until the
     tab (and machine) stalls. Run the whole thing exactly once per page. */
  if(window.__heliaonInit)return; window.__heliaonInit=true;
  if(!document.getElementById('heliaon'))return;
  var design=!!(window.Shopify&&(window.Shopify.designMode===true||window.Shopify.designMode==="true"));
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qsa=function(s){return document.querySelectorAll(s);};
  var still=design||reduce; /* "still" = no scroll-driven motion (editor or reduced-motion) */

  /* ---- reveals (incl. directional .rv / mask .rv-mask) ---- */
  if(still){
    qsa('.reveal,.rv,.rv-mask').forEach(function(el){el.classList.add('in');});
  }else{
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0});
    qsa('.reveal,.rv,.rv-mask').forEach(function(el){io.observe(el);});
  }

  /* ---- showcase scroll-cycling (homepage) ---- */
  var showcase=document.getElementById('hln-showcase');
  var scItems=qsa('#hln-scStage .sc-item');
  var scMetas=qsa('#hln-scMeta .sc-meta');
  var scNum=document.getElementById('hln-scNum');
  function setScHeight(){if(showcase&&scItems.length){if(window.innerWidth<=959){showcase.style.height='auto';return;}showcase.style.height=(scItems.length*72)+'vh';}}
  var curIdx=0;
  function onScrollShowcase(){
    if(!showcase||!scItems.length)return;
    if(window.innerWidth<=959)return; /* mobile = #hln-sccar carousel, no pinned scrub (no iOS wobble) */
    var r=showcase.getBoundingClientRect();
    var total=showcase.offsetHeight-window.innerHeight;
    var prog=Math.min(1,Math.max(0,(-r.top)/total));
    var idx=Math.min(scItems.length-1,Math.floor(prog*scItems.length));
    if(idx!==curIdx){curIdx=idx;
      scItems.forEach(function(el,i){el.classList.toggle('active',i===idx);});
      scMetas.forEach(function(el,i){el.classList.toggle('active',i===idx);});
      if(scNum)scNum.textContent=('0'+(idx+1)).slice(-2);
    }
  }

  /* ---- header: CSS position:sticky (from base css). Solid background switched by ONE
     IntersectionObserver on the announcement bar — NO per-scroll JS, no transforms, no layout
     reads → the header can never desync from native scroll (kills the shake on iOS + desktop). */
  var header=document.getElementById('hln-header');
  var topbar=document.querySelector('.hln-topbar');
  if(header){
    if(topbar&&'IntersectionObserver'in window){
      new IntersectionObserver(function(es){header.classList.toggle('solid',!es[0].isIntersecting);},{threshold:0}).observe(topbar);
    }else{header.classList.add('solid');}
  }
  function scrollWork(){onScrollShowcase();}

  /* BUG2 FIX: the homepage showcase scrub now runs in ALL contexts, INCLUDING the theme editor
     (designMode) — previously the if(design) branch disabled it entirely. It also RE-BINDS when the
     editor re-renders the section (shopify:section:load), re-querying the nodes so an item added in
     the editor (e.g. a 6th) is picked up. Height + active-index math derive from the live
     scItems.length (no hardcoded count). One global scroll listener, so re-binds never accumulate. */
  function bindShowcase(){
    showcase=document.getElementById('hln-showcase');
    scItems=qsa('#hln-scStage .sc-item');
    scMetas=qsa('#hln-scMeta .sc-meta');
    scNum=document.getElementById('hln-scNum');
    curIdx=-1;
    if(!showcase||!scItems.length)return;
    setScHeight();
    scrollWork();
  }
  var scTicking=false;
  function scOnScroll(){if(scTicking)return;scTicking=true;requestAnimationFrame(function(){scrollWork();scTicking=false;});}
  window.addEventListener('scroll',scOnScroll,{passive:true});
  window.addEventListener('resize',function(){setScHeight();scrollWork();});
  document.addEventListener('shopify:section:load',function(e){if(e&&e.target&&((e.target.id==='hln-showcase')||(e.target.querySelector&&e.target.querySelector('#hln-showcase')))){bindShowcase();}});
  bindShowcase();

  /* ---- reviews count-up moved to the robust R11 controller near the end (hlnCountUp) ---- */

  /* ---- mobile menu ---- */
  var mm=document.getElementById('hln-mobileMenu');
  var bg=document.getElementById('hln-burger');if(bg)bg.onclick=function(){mm.classList.add('open');};
  var mc=document.getElementById('hln-menuClose');if(mc)mc.onclick=function(){mm.classList.remove('open');};
  if(mm)mm.querySelectorAll('a').forEach(function(a){a.onclick=function(){mm.classList.remove('open');};});

  /* ---- PDP Vitrine: sticky morphing stage + configurator ---- */
  vitrine();
  function vitrine(){
    var root=document.getElementById('hln-vit');if(!root)return;
    var scenes=root.querySelectorAll('.vit__scene');
    function setScene(name){scenes.forEach(function(s){s.classList.toggle('is-on',s.getAttribute('data-scene')===name);});}
    setScene('config');
    var mini=root.querySelector('.vit__mini');
    var straps=root.querySelectorAll('.vit__strap');
    var dots=root.querySelectorAll('.vit__dot');
    var moodB=root.querySelector('.vit__mood b'),moodS=root.querySelector('.vit__mood span');
    function setStrap(i){
      straps.forEach(function(s,k){s.classList.toggle('is-on',k===i);});
      dots.forEach(function(d,k){d.classList.toggle('is-on',k===i);});
      var act=straps[i];if(!act)return;
      if(moodB)moodB.textContent=act.getAttribute('data-name')||'';
      if(moodS)moodS.textContent=act.getAttribute('data-mood')||'';
      if(mini){var mi=mini.querySelector('img'),si=act.querySelector('img');if(mi&&si)mi.src=si.currentSrc||si.src;}
    }
    dots.forEach(function(d,k){d.addEventListener('click',function(){setStrap(k);});});
    if(straps.length)setStrap(0);
    if(design)return; /* editor: no scroll observers */
    var beats=root.querySelectorAll('.vit__beat[data-scene]');
    if(beats.length){
      var bio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)setScene(e.target.getAttribute('data-scene'));});},{rootMargin:'-45% 0px -45% 0px'});
      beats.forEach(function(b){bio.observe(b);});
    }
    if(mini){
      var anchor=root.querySelector('.vit__buy')||root.querySelector('.vit__stage');
      if(anchor){var mio=new IntersectionObserver(function(es){es.forEach(function(e){mini.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0);});},{threshold:0});mio.observe(anchor);}
    }
  }

  /* ====================== v6 PDP controllers ====================== */
  /* shared rAF scroll engine (one listener, registered callbacks) */
  var fxItems=[],fxTick=false;
  function fxRun(){var vh=window.innerHeight||document.documentElement.clientHeight;var rects=[],i;for(i=0;i<fxItems.length;i++){rects[i]=fxItems[i].el.getBoundingClientRect();}for(i=0;i<fxItems.length;i++){fxItems[i].cb(rects[i],vh);}}
  function fxOnScroll(){if(fxTick)return;fxTick=true;requestAnimationFrame(function(){fxRun();fxTick=false;});}
  function fxReg(el,cb){fxItems.push({el:el,cb:cb});}
  function fxStart(){if(fxItems.length){window.addEventListener('scroll',fxOnScroll,{passive:true});window.addEventListener('resize',fxOnScroll);fxRun();}}

  /* 4 · evergreen countdown */
  (function(){
    var box=document.getElementById('hln-cd');if(!box)return;
    var hEl=box.querySelector('[data-h]'),mEl=box.querySelector('[data-m]'),sEl=box.querySelector('[data-s]');
    var dur=parseInt(box.getAttribute('data-dur'),10)||3600;
    function f(n){return('0'+n).slice(-2);}
    function paint(rem){var h=Math.floor(rem/3600),m=Math.floor((rem%3600)/60),s=Math.floor(rem%60);if(hEl)hEl.textContent=f(h);if(mEl)mEl.textContent=f(m);if(sEl)sEl.textContent=f(s);}
    if(still){paint(dur);return;}
    var start=performance.now(),last=-1,cdRaf=0,cdPaused=false;
    (function loop(now){if(cdPaused){cdRaf=0;return;}var el=(now-start)/1000,rem=dur-(el%dur),sec=Math.floor(rem);if(sec!==last){last=sec;paint(rem);}cdRaf=requestAnimationFrame(loop);})(start);
    document.addEventListener('visibilitychange',function(){if(document.hidden){cdPaused=true;if(cdRaf){cancelAnimationFrame(cdRaf);cdRaf=0;}}else{cdPaused=false;start=performance.now()-((dur-((last<0?dur:last))))*1000;last=-1;cdRaf=requestAnimationFrame(function l(now){if(cdPaused)return;var el=(now-start)/1000,rem=dur-(el%dur),sc=Math.floor(rem);if(sc!==last){last=sc;paint(rem);}cdRaf=requestAnimationFrame(l);});}});
  })();

  /* 7 · automatic delivery-date range (Europe/Athens, cutoff + weekend skip; mobile+desktop) */
  (function(){
    var el=document.getElementById('hln-delivery');if(!el)return;
    try{
      var cut=(el.getAttribute('data-cutoff')||'15:00').split(':');
      var ch=parseInt(cut[0],10);if(isNaN(ch))ch=15;var cm=parseInt(cut[1],10)||0;
      var minD=parseInt(el.getAttribute('data-min'),10)||2,maxD=parseInt(el.getAttribute('data-max'),10)||3;
      var now=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Athens'}));
      var ship=new Date(now);
      if(now.getHours()>ch||(now.getHours()===ch&&now.getMinutes()>=cm))ship.setDate(ship.getDate()+1);
      function skip(d){while(d.getDay()===0||d.getDay()===6)d.setDate(d.getDate()+1);return d;}
      function addBiz(d,n){var r=new Date(d),a=0;while(a<n){r.setDate(r.getDate()+1);if(r.getDay()!==0&&r.getDay()!==6)a++;}return r;}
      skip(ship);
      var lo=skip(addBiz(ship,minD)),hi=skip(addBiz(ship,maxD));
      var __lm=location.pathname.match(/\/products\/(pl|cz|ro|hu)-/);
      var __loc=el.getAttribute('data-loc')||(__lm?({pl:'pl-PL',cz:'cs-CZ',ro:'ro-RO',hu:'hu-HU'})[__lm[1]]:'el-GR');
      var __sepmap={'pl-PL':' do ','cs-CZ':' do ','ro-RO':' pănă la ','hu-HU':' és ','el-GR':' έως '};var __sep=__sepmap[__loc]||' έως ';
      function f(d,wm){var o={day:'numeric'};if(wm)o.month='short';try{return d.toLocaleDateString(__loc,o);}catch(e){return d.getDate()+(wm?('.'+(d.getMonth()+1)):'');}}
      if(lo.getTime()===hi.getTime()){el.textContent=f(lo,true);}else if(lo.getMonth()===hi.getMonth()){el.textContent=f(lo,false)+__sep+f(hi,true);}else{el.textContent=f(lo,true)+__sep+f(hi,true);}
    }catch(e){/* keep server-side fallback text */}
  })();

  /* 5+10 · strap cards — depth tilt (subtle on desktop = sharp), photo parallax, center-card
     underline; click-to-center, pointer-drag, keyboard. Mobile params kept (mobile is approved). */
  (function(){
    var rail=document.getElementById('hln-thc-rail');if(!rail)return;
    var cards=rail.querySelectorAll('.thc__card');if(!cards.length)return;
    for(var z=0;z<cards.length;z++)cards[z].setAttribute('tabindex','0');
    if(still){for(var z2=0;z2<cards.length;z2++)cards[z2].classList.add('is-mid');return;}
    var wide=window.innerWidth>=960;
    var maxRY=wide?4:8, drop=wide?0.02:0.06, par=wide?10:12;
    function centerCard(i){var card=cards[i];if(!card)return;rail.scrollTo({left:card.offsetLeft-(rail.clientWidth-card.offsetWidth)/2,behavior:'smooth'});}
    var t=false,midIdx=-1;
    function upd(){
      var rc=rail.getBoundingClientRect(),cx=rc.left+rc.width/2,best=1e9,bi=0;
      for(var i=0;i<cards.length;i++){var b=cards[i].getBoundingClientRect(),c=b.left+b.width/2,d=Math.max(-1,Math.min(1,(c-cx)/(rc.width/2))),ad=Math.abs(c-cx);
        if(ad<best){best=ad;bi=i;}
        var ry=(-d*maxRY).toFixed(2),sc=(1-Math.min(drop,Math.abs(d)*drop/0.6)).toFixed(3);
        cards[i].style.transform='rotateY('+ry+'deg) scale('+sc+')';
        var img=cards[i].querySelector('.thc__media img');if(img)img.style.setProperty('--py',(-d*par).toFixed(1)+'px');
      }
      if(bi!==midIdx){midIdx=bi;for(var k=0;k<cards.length;k++)cards[k].classList.toggle('is-mid',k===bi);}
    }
    function on(){if(t)return;t=true;requestAnimationFrame(function(){upd();t=false;});}
    rail.addEventListener('scroll',on,{passive:true});window.addEventListener('resize',function(){wide=window.innerWidth>=960;maxRY=wide?4:8;drop=wide?0.02:0.06;par=wide?10:12;on();},{passive:true});upd();
    var moved=false;
    for(var j=0;j<cards.length;j++){(function(idx){
      cards[idx].addEventListener('click',function(){if(!moved)centerCard(idx);});
      cards[idx].addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();centerCard(Math.min(cards.length-1,idx+1));}else if(e.key==='ArrowLeft'){e.preventDefault();centerCard(Math.max(0,idx-1));}else if(e.key==='Enter'||e.key===' '){e.preventDefault();centerCard(idx);}});
    })(j);}
    var down=false,sx=0,sl=0;
    rail.addEventListener('pointerdown',function(e){if(e.pointerType==='touch')return;down=true;moved=false;sx=e.clientX;sl=rail.scrollLeft;try{rail.setPointerCapture(e.pointerId);}catch(_){}rail.classList.add('drag');});
    rail.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>4)moved=true;rail.scrollLeft=sl-dx;});
    function endDrag(){if(!down)return;down=false;rail.classList.remove('drag');setTimeout(function(){moved=false;},0);}
    rail.addEventListener('pointerup',endDrag);rail.addEventListener('pointercancel',endDrag);
  })();

  /* 6 · PDP features showcase — ISOLATED from the homepage showcase (own #hln-fx2 ids) so mobile
     can be tuned without touching the homepage/desktop. Fixes: longer mobile runway, STABLE pin
     (runway denominator from a captured viewport height, not live innerHeight → no iOS toolbar
     jitter), and hysteresis around each boundary so the active index can't flap.
     BUG2 FIX (IDENTICAL to the homepage showcase fix): the pinned scrub now runs in the theme editor
     (designMode) instead of collapsing to a static stack — the old `if(still)` short-circuit included
     designMode. It now gates on `reduce` ONLY, so reduced-motion users still get the static stack.
     It RE-BINDS on shopify:section:load (re-querying nodes) so the editor's re-render can't kill it,
     and the item count + runway derive from the live items.length on every bind (no hardcoded count). */
  (function(){
    var sec,items,metas,num,sticky,stage,n,shown,vh,secTop,total,cur,lastW,t=false;
    function paint(idx){if(idx===shown)return;shown=idx;for(var k=0;k<n;k++){items[k].classList.toggle('active',k===idx);if(metas[k])metas[k].classList.toggle('active',k===idx);}if(num)num.textContent=('0'+(idx+1)).slice(-2);}
    function measure(){
      if(!sec||!n)return;
      lastW=window.innerWidth;
      if(window.innerWidth<=959){
        /* MOBILE: the pinned showcase is display:none — the #hln-fxcar swipe carousel takes over.
           No pinning at all on mobile → the iOS position:sticky wobble cannot occur. */
        sec.style.height='auto';if(sticky)sticky.style.height='';if(stage)stage.style.maxHeight='';
        return;
      }
      /* DESKTOP: pinned scrub (CSS 100vh/62vh; px runway) */
      vh=window.innerHeight||document.documentElement.clientHeight;
      if(sticky)sticky.style.height='';if(stage)stage.style.maxHeight='';
      sec.style.height=Math.round(n*0.72*vh)+'px';
      var r=sec.getBoundingClientRect();secTop=r.top+window.scrollY;
      total=Math.max(1,sec.offsetHeight-vh);
    }
    function upd(){
      if(!sec||!n||reduce)return;
      if(window.innerWidth<=959)return; /* mobile = carousel, no pinned scrub */
      /* scrollY is a cheap property read (no forced layout) — no getBoundingClientRect in the scroll path */
      var prog=Math.min(1,Math.max(0,(window.scrollY-secTop)/total));
      while(cur<n-1 && prog >= (cur+1)/n + 0.02){cur++;}
      while(cur>0 && prog < cur/n - 0.02){cur--;}
      paint(cur);
    }
    function on(){if(t)return;t=true;requestAnimationFrame(function(){upd();t=false;});}
    function bindFx2(){
      sec=document.getElementById('hln-fx2');if(!sec)return;
      items=sec.querySelectorAll('#hln-fx2Stage .sc-item');metas=sec.querySelectorAll('#hln-fx2Meta .sc-meta');num=document.getElementById('hln-fx2Num');
      sticky=sec.querySelector('.showcase__sticky');stage=document.getElementById('hln-fx2Stage');
      n=items.length;if(!n)return;
      shown=-1;cur=0;
      if(reduce){sec.style.height='auto';paint(0);return;} /* reduced-motion: static stack (accessibility) */
      measure();paint(0);on();
    }
    bindFx2();
    window.addEventListener('scroll',on,{passive:true});
    /* recalc ONLY on width change / orientation — ignore iOS URL-bar height-only resizes that fire mid-scroll */
    window.addEventListener('resize',function(){if(window.innerWidth!==lastW){measure();on();}},{passive:true});
    window.addEventListener('orientationchange',function(){setTimeout(function(){measure();on();},200);});
    /* editor re-render: re-bind so the scrub survives shopify:section:load */
    document.addEventListener('shopify:section:load',function(e){if(e&&e.target&&((e.target.id==='hln-fx2')||(e.target.querySelector&&e.target.querySelector('#hln-fx2')))){bindFx2();}});
  })();

  /* 6b · reusable MOBILE carousel counter — strap-cards mechanics: rail-scroll only (no page-scroll
     listener, no position:sticky, no per-frame transform/opacity writes) → cannot wobble on iOS.
     Updates the 01/0N counter + .is-mid on snap. Used by PDP features (#hln-fxcar) AND homepage
     showcase (#hln-sccar). Desktop never reaches these (carousels are display:none >=960). */
  function hlnRailCounter(railId,cardSel,numId){
    var rail=document.getElementById(railId);if(!rail)return;
    var cards=rail.querySelectorAll(cardSel),num=document.getElementById(numId);
    if(!cards.length)return;
    var t=false,shown=-1;
    function upd(){
      var rc=rail.getBoundingClientRect(),cx=rc.left+rc.width/2,best=1e9,bi=0;
      for(var i=0;i<cards.length;i++){var b=cards[i].getBoundingClientRect(),c=b.left+b.width/2,d=Math.abs(c-cx);if(d<best){best=d;bi=i;}}
      if(bi!==shown){shown=bi;if(num)num.textContent=('0'+(bi+1)).slice(-2);for(var k=0;k<cards.length;k++)cards[k].classList.toggle('is-mid',k===bi);}
    }
    function on(){if(t)return;t=true;requestAnimationFrame(function(){upd();t=false;});}
    rail.addEventListener('scroll',on,{passive:true});upd();
  }
  hlnRailCounter('hln-fxcar-rail','.fxcar__card','hln-fxcarNum');
  hlnRailCounter('hln-sccar-rail','.sccar__card','hln-sccarNum');

  /* 9 · design story — scroll-scrubbed sketch->real cross-fade + headline land (mobile+desktop) */
  (function(){
    var sec=document.getElementById('hln-dx');if(!sec)return;
    var sk=sec.querySelector('.dx__sketch'),re=sec.querySelector('.dx__real'),hd=sec.querySelector('.dx__head');
    if(still){sec.classList.add('is-still');return;}
    if(sk)sk.style.clipPath='none';
    fxReg(sec,function(r,vh){
      var p=(vh-r.top)/(vh+r.height);p=Math.max(0,Math.min(1,p));
      var x=Math.max(0,Math.min(1,(p-0.16)/0.40));if(sk)sk.style.opacity=(1-x).toFixed(3);if(re)re.style.opacity=x.toFixed(3);
      if(hd)hd.classList.toggle('land',p>0.5);
    });
  })();

  /* parallax: any [data-px] (waterproof bg, materials img, cta layers) */
  (function(){
    if(still)return;
    var els=qsa('[data-px]');if(!els.length)return;
    els.forEach(function(el){var amt=parseFloat(el.getAttribute('data-px'))||40;fxReg(el,function(r,vh){if(r.bottom<0||r.top>vh)return;var p=(vh-r.top)/(vh+r.height);el.style.transform='translate3d(0,'+(((p-0.5)*amt).toFixed(1))+'px,0)';});});
  })();

  /* 13 · closing CTA perspective tilt — scroll-linked rotateX + rotateY (<=6deg each), parallax via [data-px] */
  (function(){
    var sec=document.getElementById('hln-cc');if(!sec||still)return;
    var inner=sec.querySelector('.pcta__inner');if(!inner)return;
    fxReg(sec,function(r,vh){var c=(r.top+r.height/2-vh/2)/vh;c=Math.max(-1,Math.min(1,c));inner.style.transform='rotateX('+(-c*5).toFixed(2)+'deg) rotateY('+(c*4).toFixed(2)+'deg)';});
  })();

  /* materials callout draw-in (IO) */
  (function(){
    var sec=document.getElementById('hln-ml');if(!sec)return;
    if(still){sec.classList.add('in');return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){sec.classList.add('in');io.disconnect();}});},{threshold:.3});
    io.observe(sec);
  })();

  /* (copper thread removed in round 3 per owner request) */

  /* global mobile sticky COD bar (show after buy button scrolls away) */
  (function(){
    var bar=document.getElementById('hln-cod');if(!bar||design)return;
    var anchor=document.getElementById('hln-buy-button')||document.getElementById('hln-pb');
    if(!anchor)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){bar.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0);});},{threshold:0});
    io.observe(anchor);
  })();

  /* R7 · quantity stepper — click handlers only (no scroll), wired to name="quantity" in /cart/add form */
  (function(){
    var wrap=document.getElementById('hln-qty-wrap');if(!wrap)return;
    var input=document.getElementById('hln-qty');if(!input)return;
    var max=parseInt(wrap.getAttribute('data-max'),10)||5;if(max<1)max=1;
    var minus=wrap.querySelector('[data-q="-1"]'),plus=wrap.querySelector('[data-q="1"]');
    function clamp(n){n=parseInt(n,10);if(isNaN(n)||n<1)n=1;if(n>max)n=max;return n;}
    function reflect(){var v=clamp(input.value);if(minus)minus.disabled=(v<=1);if(plus)plus.disabled=(v>=max);}
    function set(n){input.value=clamp(n);reflect();}
    wrap.addEventListener('click',function(e){
      var b=e.target.closest('.pb__qtybtn');if(!b||b.disabled)return;
      set(clamp(input.value)+parseInt(b.getAttribute('data-q'),10));
    });
    input.addEventListener('input',function(){input.value=input.value.replace(/[^0-9]/g,'');reflect();});
    input.addEventListener('blur',function(){set(input.value);});
    var form=document.getElementById('hln-pdp-form');if(form)form.addEventListener('submit',function(){input.value=clamp(input.value);});
    set(input.value);
  })();

  /* R7 · greek-menu signature — DESKTOP-ONLY mouse-follow tilt on the watch (rAF, max 4deg, resets on
     leave). No scroll listener, no mobile path → cannot vibrate on iOS. Chips reveal via the IO above
     and float via pure CSS. */
  (function(){
    var stage=document.getElementById('hln-gk-stage'),watch=document.getElementById('hln-gk-watch');
    if(!stage||!watch||still)return;
    if(!(window.matchMedia&&window.matchMedia('(min-width:960px) and (hover:hover) and (pointer:fine)').matches))return;
    var t=false,tx=0,ty=0;
    function apply(){watch.style.transform='rotateX('+ty.toFixed(2)+'deg) rotateY('+tx.toFixed(2)+'deg)';t=false;}
    stage.addEventListener('pointermove',function(e){
      var r=stage.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width-0.5,py=(e.clientY-r.top)/r.height-0.5;
      tx=Math.max(-1,Math.min(1,px*2))*4;ty=Math.max(-1,Math.min(1,py*2))*-4;
      if(!t){t=true;requestAnimationFrame(apply);}
    });
    stage.addEventListener('pointerleave',function(){tx=0;ty=0;watch.style.transform='';});
  })();

  /* R12 · count-up — animates ONLY when each counter actually ENTERS the viewport (IO threshold .35 so
     it is genuinely visible when it starts), exactly once, with a per-element data-counted guard.
     Targets #heliaon [data-to] and #heliaon .fcount (reviews badge #hln-score/#hln-revcount + social
     followers). Decimals via data-decimals (parseFloat/toFixed; the 4.9 rating); integers el-GR.
     IMPORTANT (fixes the R11 regression where a global load-time setTimeout finalized EVERY counter
     ~4s after load, so by the time you scrolled down they were already at finals with no animation):
     there is NO global finalize. Off-screen counters keep their start value until scrolled to. A page
     loaded already scrolled at the section (Safari scroll restoration) fires the IO initial entry →
     animates (never instant). Reduced-motion/editor → finals instantly. BACKSTOP is strictly scoped:
     only a counter that has been INTERSECTING for ~2.5s yet is somehow still pending gets flushed —
     off-screen counters are never touched. Re-scans on window 'load' to register late-injected nodes. */
  (function(){
    function fmt(v,dp){return dp>0?v.toFixed(dp):Math.round(v).toLocaleString('el-GR');}
    function register(el){
      if(el.getAttribute('data-counted'))return null;          /* already registered or done */
      var src=el.getAttribute('data-to');if(src===null)src=el.textContent||'';
      var dp=parseInt(el.getAttribute('data-decimals'),10);if(isNaN(dp))dp=0;
      var to=dp>0?parseFloat(String(src).replace(',','.')):parseInt(String(src).replace(/[^0-9]/g,''),10);
      if(isNaN(to))return null;                                 /* not a numeric counter */
      el.setAttribute('data-counted','pending');
      var suffix=el.getAttribute('data-suffix');
      if(suffix===null)suffix=/\+/.test(el.textContent||'')?'+':'';
      var item={el:el,done:false,seen:false};
      item.flush=function(){if(item.done)return;item.done=true;el.textContent=fmt(to,dp)+suffix;el.setAttribute('data-counted','done');};
      item.run=function(){if(item.done)return;item.done=true;el.setAttribute('data-counted','done');
        var dur=1400,t0=null;
        function step(ts){if(!t0)t0=ts;var p=Math.min(1,(ts-t0)/dur);var e=1-Math.pow(1-p,3);el.textContent=fmt(to*e,dp)+suffix;if(p<1)requestAnimationFrame(step);else el.textContent=fmt(to,dp)+suffix;}
        requestAnimationFrame(step);
      };
      return item;
    }
    function observe(item){
      if('IntersectionObserver'in window){
        var io=new IntersectionObserver(function(es,obs){
          for(var k=0;k<es.length;k++){
            if(es[k].isIntersecting){
              /* backstop ONLY for an element that is genuinely in view: if still pending 2.5s later, finalize */
              if(!item.seen){item.seen=true;setTimeout(function(){if(!item.done)item.flush();},2500);}
              item.run();obs.disconnect();break;
            }
          }
        },{threshold:0.35});
        io.observe(item.el);
      }else{item.run();}
    }
    function scan(){
      var els=document.querySelectorAll('#heliaon [data-to], #heliaon .fcount');
      for(var i=0;i<els.length;i++){
        var it=register(els[i]);if(!it)continue;
        if(still){it.flush();continue;}
        observe(it);
      }
    }
    scan();
    if(window.addEventListener)window.addEventListener('load',function(){scan();},{once:true});
  })();

  fxStart();

})();
/* ===== HLN-MQPERF-2026: marquee visibility gate ===================================
   Every marquee (press, trust, reviews, coverflow photos, greek river) is a pure-CSS
   translate animation that ran continuously, on-screen or not. On a long PDP that is
   ~6 large compositor layers all animating at once (the photo coverflow alone is a
   ~10800px / 42-card layer that exceeds the mobile GPU texture cap), which drops frames
   across every marquee. This pauses a marquee while it is off-screen and frees its
   promoted layer, so the compositor only ever drives the marquees actually in view.
   Purely a performance gate: the visible marquee animates exactly as before. */
;(function(){
  if(window.__hlnMqPerf)return; window.__hlnMqPerf=1;
  var SEL='.prs__track,.mq__track,.rv2__row,.hln-cph__row,.gk__rivertrack,.wcp__row';
  var tracks=[].slice.call(document.querySelectorAll(SEL));
  if(!tracks.length)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design=!!(window.Shopify&&(window.Shopify.designMode===true||window.Shopify.designMode==="true"));
  if(reduce||design||!('IntersectionObserver' in window))return;
  function pause(t){t.style.setProperty('animation-play-state','paused','important');t.style.willChange='auto';}
  function play(t){t.style.removeProperty('animation-play-state');t.style.willChange='transform';}
  var io=new IntersectionObserver(function(es){
    for(var i=0;i<es.length;i++){ if(es[i].isIntersecting){play(es[i].target);}else{pause(es[i].target);} }
  },{rootMargin:'150px 0px'});
  for(var j=0;j<tracks.length;j++){ io.observe(tracks[j]); }
})();
